import type { ReactNode } from 'react';

export function Field({ label, hint, children }: { label: string; hint?: ReactNode; children: ReactNode }) {
  return (
    <div className="fld">
      <label className="lbl">{label}</label>
      {children}
      {hint ? <p className="hint">{hint}</p> : null}
    </div>
  );
}

/** The three-across row every form here uses. */
export function Row({ cols = 3, children }: { cols?: number | string; children: ReactNode }) {
  return (
    <div className="form-row" style={{
      display: 'grid',
      gridTemplateColumns: typeof cols === 'number' ? `repeat(${cols}, minmax(0, 1fr))` : cols,
      gap: 14,
    }}>{children}</div>
  );
}

export function StateTag({ state }: { state: string }) {
  const good = state === 'published' || state === 'queued';
  return (
    <span className="tg" style={{ background: good ? 'rgba(62,207,142,.14)' : 'rgba(var(--wash), calc(.06 * var(--washx)))' }}>
      {state}
    </span>
  );
}

/**
 * A credential box Chrome will not fill for you.
 *
 * `autocomplete="new-password"` is a request, not a rule — Chrome offers the
 * password it has saved for the console itself, and the dots look exactly like
 * a stored secret. Saving then seals the wrong string: an SMTP or MSG91 key
 * that fails at send time, hours later, with an authentication error nobody
 * connects back to this form. A field that is read-only until focused is not
 * offered a suggestion, so what gets stored is only ever what was typed.
 */
export function SecretInput(props: {
  value: string;
  onChange: (v: string) => void;
  disabled?: boolean;
  placeholder?: string;
}) {
  return (
    <input
      className="inp" type="password" autoComplete="off" spellCheck={false}
      readOnly disabled={props.disabled} value={props.value}
      placeholder={props.placeholder}
      onFocus={(e) => { e.currentTarget.readOnly = false; }}
      onChange={(e) => props.onChange(e.target.value)}
    />
  );
}
